/**
 * Generic OAuth 2.0 types and utilities.
 */

// tslint:disable: interface-name

export interface OAuthProviderConfig {
    poolId: string
    clientId: string
    authorizationEndpoint: string
    tokenEndpoint: string
    authType: string
    // Owning org of the entered domain (from GetDomainConfiguration). Used by the cross-org
    // sign-in guard to compare against the caller's org set. Optional (absent on older gateway).
    organizationId?: string
    providerMetadata?: Record<string, string>
}

export interface OAuthTokenResponse {
    access_token: string
    refresh_token?: string
    id_token?: string
    token_type: string
    expires_in: number
}

export interface StoredTokens {
    accessToken: string
    refreshToken?: string
    idToken?: string
    expiresIn: number
    expiresAt: number
}

export interface IOAuthProvider {
    buildAuthUrl (
        config: OAuthProviderConfig,
        codeChallenge: string,
        redirectUri: string,
        state: string,
    ): string

    exchangeCodeForTokens (
        config: OAuthProviderConfig,
        code: string,
        codeVerifier: string,
        redirectUri: string,
    ): Promise<StoredTokens>
}

const EXPIRY_BUFFER_MS = 60_000

export function isTokenExpired (tokens: StoredTokens | null): boolean {
    if (!tokens?.expiresAt) return true
    return Date.now() >= tokens.expiresAt - EXPIRY_BUFFER_MS
}
